export default function genererCritereRechercheRetard(clientPayeur) {
  return {
    dates: {
      dateDebut: null,
      dateFin: new Date(),
    },
    commercialId: null,
    datesFacture: {
      dateDebut: null,
      dateFin: null,
    },
    agenceIdFacture: [],
    payeurs: clientPayeur ? [clientPayeur] : [],
    blocageReglement: false,
    datesLastRelance: {
      dateDebut: null,
      dateFin: null,
    },
    noDateLastRelance: null,
    produits: [],
    comptesComptables: [],
    niveauDerniereRelance: null,
    nePasRelancer: false,
    modesReglementsIds: [],
  };
}
